import { TextField, Typography, Container, Button, CircularProgress, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, resetPassword } from '../../Actions/Auth';
import PasswordIcon from '@mui/icons-material/Password';
import EmailIcon from '@mui/icons-material/Email';


const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(state => state.user.isLoading);

  const token= useParams()


  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validate = Yup.object().shape({
    // email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character',
    )
    .required('Password is Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Required'),
  });

  const formik = useFormik({
    initialValues: {
    //  email:'',
      password: '',
      confirmPassword:''
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
        console.log(token.id)
      dispatch(
        resetPassword(
          {
            // email:values.email,
            password: values.password,
            confirmPassword: values.confirmPassword
          },
          navigate,
          token.id
        ),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
    },
  });

  return (
    <div>
      <Container
        sx={{
          width: ['100%', '50%', '40%', '30%'],
          height: ['100%', '100%', '100%'],
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          my: 20,
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            marginTop: ['80px', '80px', '80x'],
            paddingLeft: '0px',
            paddingRight: '0px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'Column',
            boxShadow: '0px 3px 45px #71380C12',
          }}
        >
         
          <div style={{width:"100%",backgroundColor:"#FF7345",height:"20px"}}></div>
          <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
            <Typography sx={{ marginTop: '20px', fontWeight: '700', fontFamily: 'Sora', px: 2 }} variant="h5">
              Please Enter Your <span style={{ color: '#FF7345' }}>New Password</span>
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
            {/* <TextField
                id="email"
                name="email"
                placeholder="Email Id"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                // error="This is error"
                // helperText="There is error"

                sx={{
                  width: '100%',
                  borderRadius: '5px',
                  backgroundColor: '#F6F7F9',
                  '& input::placeholder': {
                    fontFamily: 'Sora',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    marginTop: '30px',
                   
                  }, outlineColor: '#FF7345',
                  
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              /> */}

              <TextField
               sx={{
                width: '100%',
                borderRadius: '5px',
                backgroundColor: '#F6F7F9',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  marginTop: '30px',
                 
                }, outlineColor: '#FF7345',
                marginTop:"30px",
               
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon />
                  </InputAdornment>
                ),
              }}
                id="password"
                name="password"
                type="password"
                placeholder="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                // error="This is error"
                // helperText="There is error
                
              />

<TextField
               sx={{
                width: '100%',
                borderRadius: '5px',
                backgroundColor: '#F6F7F9',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  marginTop: '30px',
                 
                }, outlineColor: '#FF7345',
                marginTop:"30px",
               
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon />
                  </InputAdornment>
                ),
              }}
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Confirm Password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
              helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                // error="This is error"
                // helperText="There is error
                
              />
           
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            
              {loading ? (
                <CircularProgress></CircularProgress>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    width: '80%',
                    marginTop: '10px',
                    backgroundColor: '#FF7345',
                    fontFamily: 'Sora',
                    marginBottom: '20px',
                    display: 'flex',
                    
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: '#d95429',
                    },
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              )}
              
            </div>
           
          </form>
    
        </div>
      </Container>
    </div>
  );
};
export default ResetPassword;
